import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APIHandler } from 'C4';
import { name } from 'settings';
import clsx from 'clsx';

/**
 * @typedef {object} DiplomaProps
 * @property {number} appId Number id of the app.
 * @property {string} firstName String first name of the user.
 * @property {string} lastName String last name of the user.
 */

/**
 * A diploma component that diplays a diploma.
 * 
 * @param {DiplomaProps} props Props
 */
export default class Diploma extends Component {
  constructor(props) {
    super(props);

    this.state = {
      diplomaLoaded: false,
    };
  }

  toggle(diplomaLoaded) {
    this.setState({ diplomaLoaded });
  }

  render() {
    const {
      appId,
      firstName,
      lastName,
      hide=false, // temp prop to hide deploma (simulating original behavior)
    } = this.props;

    const image = `https://accounts.travpromobile.com/diploma_api?firstName=${firstName}&lastName=${lastName}&appID=${appId}`;
    const subject = encodeURIComponent(i18n.translate('sharing.shareSubjectDiploma'));
    const body = encodeURIComponent(`${i18n.translate('sharing.shareBodyDiploma')}\n\n${image}`);

    return (
      <div id="diploma" className={clsx("fancybox-share", "diploma", {"diploma--hidden" : hide})}>
        <img
          className="diploma__image"
          name="diploma"
          src={image}
          alt="diploma"
          loading="lazy"
        />
        <div className="buttons__diploma">
          <a
            href={`/print/${encodeURIComponent(firstName)}/${encodeURIComponent(lastName)}/${appId}`}
            disabled={!this.state.diplomaLoaded}
            className="fancybox-share__button fancybox-share__button--fb"
          >
            <FontAwesomeIcon icon={['fas', 'print']} />
            {i18n.translate('reportCard.print')}
          </a>
          <a
            href={`mailto:?subject=${subject}&body=${body}`}
            className="fancybox-share__button fancybox-share__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'at']} />
            <span>{i18n.translate('reportCard.email')}</span>
          </a>
          <a
            href={APIHandler.getDownloadURL(image)}
            download={`${subject}.png`}
            className="fancybox-download__button fancybox-download__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'download']} />
            <span>{i18n.translate('reportCard.download')}</span>
          </a>
        </div>
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

Diploma.defaultProps = {
  appId: -1,
  firstName: '',
  lastName: '',
};
